"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadFile = void 0;
var downloadFile = function (uri, filename) {
    if (filename === void 0) { filename = 'file'; }
    
    // Fix Mixed Content error: ensure HTTPS
    var secureUri = uri.replace(/^http:/, 'https:');
    
    // Most reliable method: direct navigation
    // The server's Content-Disposition header will trigger download
    window.location.href = secureUri;
};
exports.downloadFile = downloadFile;
